import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";
import regresaBienFecha from '../tools/regresaBienFecha'
import * as XLSX from 'xlsx';
/* =========================
   🎨 ESTILOS PDF
========================= */
const stylesPDF = StyleSheet.create({
  page: { padding: 15, fontSize: 9 },
  title: { fontSize: 14, marginBottom: 8, textAlign: "center", fontWeight: "bold" },
  alumno: { marginBottom: 10 },

  escuelaBox: {
    marginBottom: 14,
    paddingBottom: 6,
  },

  escuelaTitle: {
    fontSize: 11,
    fontWeight: "bold",
  },

  cursoBox: {
    marginLeft: 8,
    marginBottom: 12,
  },

  cursoTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 4,
  },

  sectionTitle: {
    fontSize: 9,
    fontWeight: "bold",
    marginTop: 6,
    marginBottom: 4,
  },

  table: {
    borderWidth: 1,
    borderColor: "#ccc",
    marginBottom: 6,
  },

  tableRow: {
    flexDirection: "row",
  },

  tableHeader: {
    backgroundColor: "#eee",
    fontWeight: "bold",
  },

  tableCellSmall: {
    width: "25%",
    padding: 4,
    borderRightWidth: 1,
    borderColor: "#ccc",
    fontSize: 8,
  },

  tableCellLarge: {
    width: "50%",
    padding: 4,
    fontSize: 8,
  },

  /* ===== 🔽 ESTOS SON LOS QUE PREGUNTASTE 🔽 ===== */

  separator: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    marginVertical: 6,
  },

  subSeparator: {
    borderBottomWidth: 0.5,
    borderBottomColor: "#666",
    marginVertical: 4,
  },

  pageNumber: {
    position: "absolute",
    fontSize: 9,
    bottom: 20,
    right: 40,
    color: "grey",
  },

  header: {
    marginBottom: 10,
  },

  materiaBox: {
    marginBottom: 10,
  },

  materiaTitle: {
    fontWeight: "bold",
    marginBottom: 4,
  },
});


/* =========================
   📄 PDF
========================= */
const LegajoPDF = ({ alumno, data }) => (
  <Document>
    <Page size="A4" style={stylesPDF.page}>

      {/* ================= HEADER ================= */}
      <View style={stylesPDF.header} fixed>
        <Text style={stylesPDF.title}>Legajo Virtual de Cursado</Text>
      </View>

      {/* ================= FOOTER / PAGINADO ================= */}
      <Text
        style={stylesPDF.pageNumber}
        render={({ pageNumber, totalPages }) =>
          `Página ${pageNumber} de ${totalPages}`
        }
        fixed
      />

      <Text style={stylesPDF.alumno}>Alumno: {alumno}</Text>

      {/* ================= CONTENIDO ================= */}
      {Object.entries(data).map(([escuela, cursos]) => (
        <View key={escuela} style={stylesPDF.escuelaBox} wrap={false}>

          {/* ===== ESCUELA ===== */}
          <Text style={stylesPDF.escuelaTitle}>🏫 {escuela}</Text>

          <View style={stylesPDF.separator} />

          {Object.entries(cursos).map(([curso, info]) => (
            <View key={curso} style={stylesPDF.cursoBox} wrap={false}>

              {/* ===== CURSO ===== */}
              <Text style={stylesPDF.cursoTitle}>📘 {curso}</Text>

              <View style={stylesPDF.subSeparator} />

              {/* ================= AUSENCIAS ================= */}
              {info.Ausencias?.length > 0 && (
                <>
                  <Text style={stylesPDF.sectionTitle}>
                    🚫 Ausencias ({info.Ausencias.length})
                  </Text>

                  <View style={stylesPDF.table}>
                    <View style={[stylesPDF.tableRow, stylesPDF.tableHeader]}>
                      <Text style={stylesPDF.tableCellSmall}>Fecha</Text>
                      
                      <Text style={stylesPDF.tableCellLarge}>Observación</Text>
                    </View>

                    {info.Ausencias.map((a, i) => (
                      <View key={i} style={stylesPDF.tableRow}>
                        <Text style={stylesPDF.tableCellSmall}>{a.fecha}</Text>
                       
                        <Text style={stylesPDF.tableCellLarge}>
                          {a.observacion || "-"}
                        </Text>
                      </View>
                    ))}
                  </View>
                </>
              )}

              {/* ================= MATERIAS ================= */}
              {Object.entries(info).some(
                ([k]) => k !== "Ausencias" && k !== "Sin notas"
              ) && (
                <>
                  <Text style={stylesPDF.sectionTitle}>📚 Materias</Text>

                  {Object.entries(info)
                    .filter(([k]) => k !== "Ausencias" && k !== "Sin notas")
                    .map(([materia, notas]) => (
                      <View key={materia} style={stylesPDF.materiaBox} wrap={false}>
                        <Text style={stylesPDF.materiaTitle}>
                          📗 {materia}
                        </Text>

                        <View style={stylesPDF.table}>
                          <View
                            style={[stylesPDF.tableRow, stylesPDF.tableHeader]}
                          >
                            <Text style={stylesPDF.tableCellLarge}>
                              Instancia
                            </Text>
                            <Text style={stylesPDF.tableCellSmall}>
                              Nota
                            </Text>
                          </View>

                          {notas.map((n, i) => (
                            <View key={i} style={stylesPDF.tableRow}>
                              <Text style={stylesPDF.tableCellLarge}>
                                {n.nombreInstancia}
                              </Text>
                              <Text style={stylesPDF.tableCellSmall}>
                                {n.nota}
                              </Text>
                            </View>
                          ))}
                        </View>
                      </View>
                    ))}
                </>
              )}
            </View>
          ))}
        </View>
      ))}
    </Page>
  </Document>
);

const handleDescargarExcel = (alumno, data) => {
  const workbook = XLSX.utils.book_new();

  // =========================
  // 📊 HOJA RESUMEN
  // =========================
  const resumenRows = [
    ["Escuela", "Curso", "Materias Calificadas", "Inasistencias"]
  ];

  Object.entries(data).forEach(([escuela, cursos]) => {
    Object.entries(cursos).forEach(([curso, info]) => {
      const rows = [];

      // =========================
      // 🔢 CONTADORES
      // =========================
      let materiasCalificadas = 0;
      const cantidadAusencias = info.Ausencias?.length || 0;

      // =========================
      // 🏷️ TÍTULOS
      // =========================
      rows.push([`Escuela: ${escuela}`]);
      rows.push([`Curso: ${curso}`]);
      rows.push([]);

      // =========================
      // 🚫 AUSENCIAS
      // =========================
      if (cantidadAusencias > 0) {
        rows.push(["AUSENCIAS"]);
        rows.push(["Fecha", "Observación"]);

        info.Ausencias.forEach((a) => {
          rows.push([
            regresaBienFecha(a.fecha),
            a.observacion || "",
          ]);
        });

        rows.push([]);
      }

      // =========================
      // 📚 MATERIAS
      // =========================
      Object.entries(info)
        .filter(([k]) => k !== "Ausencias" && k !== "Sin notas")
        .forEach(([materia, notas]) => {

          // 👉 cuenta SOLO si tiene al menos una nota
          if (notas.length > 0) {
            materiasCalificadas++;
          }

          rows.push([`Materia: ${materia}`]);
          rows.push(["Instancia", "Nota"]);

          notas.forEach((n) => {
            rows.push([n.nombreInstancia, n.nota]);
          });

          rows.push([]);
        });

      // =========================
      // ➕ AGREGAR AL RESUMEN
      // =========================
      resumenRows.push([
        escuela,
        curso,
        materiasCalificadas,
        cantidadAusencias,
      ]);

      // =========================
      // 📄 CREAR HOJA DEL CURSO
      // =========================
      const worksheet = XLSX.utils.aoa_to_sheet(rows);

      // Nombre de hoja único (máx 31 chars)
      const sheetNames = workbook.SheetNames;
      let baseName = curso.substring(0, 25);
      let sheetName = baseName;
      let counter = 1;

      while (sheetNames.includes(sheetName)) {
        sheetName = `${baseName} (${counter})`.substring(0, 31);
        counter++;
      }

      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });
  });

  // =========================
  // 📊 CREAR HOJA RESUMEN
  // =========================
  const resumenSheet = XLSX.utils.aoa_to_sheet(resumenRows);
  XLSX.utils.book_append_sheet(workbook, resumenSheet, "Resumen");

  // =========================
  // 💾 EXPORTAR
  // =========================
  XLSX.writeFile(workbook, `Legajo-${alumno}.xlsx`);
};

/* =========================
   🧠 COMPONENTE PRINCIPAL
========================= */
export default function BuscadorAlumno() {
  const [consulta, setConsulta] = useState("");
  const [resultados, setResultados] = useState({});
  const [alumnoSeleccionado, setAlumnoSeleccionado] = useState(null);

  const handleBuscar = async () => {
    if (!consulta.trim()) return;

    try {
      const res = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveNotasYCursosPorNombre",
        { consulta }
      );
// console.log(res)
      if (Object.keys(res.data).length === 0) {
        Swal.fire("Sin resultados", "No se encontraron datos", "warning");
        setResultados({});
      } else {
        setResultados(res.data);
      }
    } catch {
      Swal.fire("Error", "Ocurrió un problema al buscar", "error");
    }
  };

  const handleDescargarPDF = async (alumno, data) => {
    const blob = await pdf(<LegajoPDF alumno={alumno} data={data} />).toBlob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Legajo-${alumno}.pdf`;
    link.click();
  };

  return (
    <div className="app-container">
      {/* BUSCADOR */}
      <div className="search-bar">
        <input
          value={consulta}
          onChange={(e) => setConsulta(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleBuscar()}
          placeholder="Buscar por DNI, Nombre o Apellido"
        />
        <button onClick={handleBuscar}>Buscar</button>
      </div>

      {/* RESULTADOS */}
      {Object.entries(resultados).map(([alumno, data]) => (
        <div className="alumno-card" key={alumno}>
          <div
            className="alumno-header"
            onClick={() =>
              setAlumnoSeleccionado(
                alumnoSeleccionado === alumno ? null : alumno
              )
            }
          >
            <span>{alumno}</span>
<div style={{ display: "flex", gap: "6px" }}>
  <button
    onClick={(e) => {
      e.stopPropagation();
      handleDescargarPDF(alumno, data);
    }}
  >
    PDF
  </button>

  <button
    onClick={(e) => {
      e.stopPropagation();
      handleDescargarExcel(alumno, data);
    }}
    style={{ background: "#16a34a" }}
  >
    Excel
  </button>
</div>
          </div>

          {alumnoSeleccionado === alumno && (
            <div className="alumno-body">
              {Object.entries(data).map(([escuela, cursos]) => (
                <details key={escuela} className="escuela" open={false}>
                  <summary>🏫 {escuela}</summary>

                  {Object.entries(cursos).map(([curso, info]) => {
                    const totalAusencias = info.Ausencias?.length || 0;

                    return (
                      <details key={curso} className="curso">
                        <summary>
//                           📘 {curso}{console.log(data)}
                          {totalAusencias > 0 && (
                            <span className="badge">{totalAusencias}</span>
                          )}
                        </summary>

                        {info.Ausencias?.length > 0 && (
                          <div className="bloque ausencias">
                            <strong>🚫 Ausencias</strong>
                            <ul>
                              {info.Ausencias.map((a, i) => (
                                <li key={i}>
                                  {regresaBienFecha(a.fecha)} – {a.estado} –{" "}
                                  {a.observacion || "-"}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                       {/* TÍTULO MATERIAS */}
{Object.entries(info).some(
  ([k]) => k !== "Ausencias" && k !== "Sin notas"
) && (
  <div className="titulo-seccion">Materias</div>
)}

{Object.entries(info)
  .filter(([k]) => k !== "Ausencias" && k !== "Sin notas")
  .map(([materia, notas]) => (
    <div key={materia} className="bloque">
      <div className="materia">{materia}</div>
      <table>
        <thead>
          <tr>
            <th>Instancia</th>
            <th>Nota</th>
          </tr>
        </thead>
        <tbody>
          {notas.map((n, i) => (
            <tr key={i}>
              <td>{n.nombreInstancia}</td>
              <td>{n.nota}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ))}

                      </details>
                    );
                  })}
                </details>
              ))}
            </div>
          )}
        </div>
      ))}

      {/* =========================
          🎨 ESTILOS
      ========================= */}
      <style jsx>{`
        .app-container {
          max-width: 900px;
          margin: auto;
          padding: 20px;
          font-family: system-ui;
        }

        .search-bar {
          display: flex;
          gap: 10px;
          margin-bottom: 20px;
        }

        input {
          flex: 1;
          padding: 10px;
          border-radius: 10px;
          border: 1px solid #ccc;
        }

        button {
          padding: 10px 16px;
          border-radius: 10px;
          border: none;
          background: #2563eb;
          color: white;
          cursor: pointer;
        }

        .alumno-card {
          border-radius: 14px;
          border: 1px solid #ddd;
          margin-bottom: 12px;
          overflow: hidden;
        }

        .alumno-header {
          background: #f1f5f9;
          padding: 14px;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          font-weight: 600;
        }

        .alumno-body {
          padding: 10px 14px;
        }

        details {
          border-radius: 12px;
          margin-bottom: 8px;
          background: #fafafa;
          padding: 6px;
        }

        summary {
          cursor: pointer;
          font-weight: 600;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .badge {
          background: #dc2626;
          color: white;
          padding: 2px 8px;
          border-radius: 999px;
          font-size: 0.75rem;
        }

        .bloque {
          margin-top: 8px;
          padding: 8px;
          background: white;
          border-radius: 10px;
        }

        .ausencias {
          background: #fee2e2;
        }

        .materia {
          font-weight: 600;
          margin-bottom: 4px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.85rem;
        }

        th,
        td {
          border-bottom: 1px solid #e5e7eb;
          padding: 6px;
          text-align: left;
        }
      `}</style>
    </div>
  );
}
